// Generated by purs version 0.15.15
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
var sequence = Ouroboros_Services_FFI_TaskEither.sequence;
var rightTask = Ouroboros_Services_FFI_TaskEither.rightTask;
var right = Ouroboros_Services_FFI_TaskEither.right;
var mapLeft = Ouroboros_Services_FFI_TaskEither.mapLeft;
var map = Ouroboros_Services_FFI_TaskEither.map;
var sequenceOk = function (tasks) {
    return map(function (v) {
        return Ouroboros_Models_Core_Ok.ok;
    })(sequence(tasks));
};
var left = Ouroboros_Services_FFI_TaskEither.left;
var fromOption = Ouroboros_Services_FFI_TaskEither.fromOption;
var fromIoEither = Ouroboros_Services_FFI_TaskEither.fromIoEither;
var fold = function (onLeft) {
    return function (onRight) {
        return function (task) {
            return Ouroboros_Services_FFI_TaskEither.fold(task)(onLeft)(onRight);
        };
    };
};
var chain = function (f) {
    return function (task) {
        return Ouroboros_Services_FFI_TaskEither.chain(task)(f);
    };
};
var tap = function (f) {
    return function (task) {
        return chain(function (value) {
            return map(function (v) {
                return value;
            })(f(value));
        })(task);
    };
};
export {
    right,
    left,
    map,
    mapLeft,
    chain,
    tap,
    fold,
    sequence,
    sequenceOk,
    rightTask,
    fromOption,
    fromIoEither
};
//# sourceMappingURL=index.js.map
